<template>
    <div ref="emergency_stop"></div>
</template>

<script>
import EmergencyStop from "!!raw-loader!../../assets/ricoh_assets/icons/ICN003-01_emergency_stop.svg" // loads SVG Icons as String via Webpack.
export default {
    mounted() {
        let shadowRoot = this.$refs.emergency_stop.attachShadow({mode: 'open'})
        shadowRoot.innerHTML = EmergencyStop

        const style = document.createElement('style')
        style.innerHTML = `svg { width: 100%; height: 100%; }`

        const clonedStyle = style.cloneNode(true)
        shadowRoot.appendChild(clonedStyle)
    }
}
</script>

<style>
</style>